// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-application[data-v-f553354c] .v-application--wrap{height:1rem!important;min-height:1rem!important}", ""]);
// Exports
module.exports = exports;
